import { Box } from '@mui/material'
import { useIsBoAdminRole } from 'hooks/useIsBoAdminRole'

export default function Descriptions() {
  const isAdminView = useIsBoAdminRole()
  if (!isAdminView) {
    return null
  }
  return (
    <Box sx={{ mt: 3, fontSize: 14 }}>
      Descriptions of the columns in the table:
      <ul>
        <li>
          <strong>Whales categories count:</strong> (whales_categories_count)
          <br /> Number of subgroups of the multisector in which the company has patents.
        </li>
        <li>
          <strong>Whales categories count normalized: </strong>
        </li>
        <li>
          <strong>Whales patent count:</strong> (whales_patent_count) [ABSOLUTE NUMBER] <br />
          Total number of patents the company has in general (after the cutoff year? active only? has claims?).
        </li>
        <li>
          <strong>Whales patent in percent (pure play ratio):</strong> The percentage of patents in the multisector that are from
          the total patents of that company. <br />F = whales_patents_in_categories / whales_patent_count x 100
        </li>
        <li>
          <strong>Whales patents in categories:</strong> whales_patents_in_categories: How many patents the company has in all the
          subgroups in the multisector.
        </li>
        <li>
          <strong>Whales patent out categories:</strong> The number of patents the company has that are not in any of the
          subgroups of the multisector. <br />
          F= whales_patent_count - whales_patents_in_categories (all categories of the multisector, not just the subgroup of the
          row)
        </li>
        <li>
          <strong>Whales patent in percent category (pure play ratio category): </strong>[DIFFERENT FOR EACH SUBGROUP]
          <br />F = whales_patents_in_category / whales_patent_count x 100
        </li>
        <li>
          <strong>Whales patent out category:</strong> [DIFFERENT FOR EACH SUBGROUP] Number of patents the company does not have
          in that subgroup. <br />
          F= whales_patent_count - whales_patents_in_category
        </li>
        <li>
          <strong>Whales patents in category:</strong>[DIFFERENT FOR EACH SUBGROUP] How many patents the company has in that
          subgroup in the subgroup of the multisector. <br />
          F= whales_patents_in_category
        </li>
      </ul>
    </Box>
  )
}
